export default class ServerError extends Error {

    constructor(xhr) {
        super('');

        this.status = parseInt(xhr.status);
        this.responseText = xhr.responseText;

        try {
            this.responseObj = JSON.parse(this.responseText);
            this.title = this.responseObj.error;
            this.errorDescription = this.responseObj.error_description;
            this.message = "[" + this.status + "][" + this.title + "] " + this.errorDescription;
        } catch (e) {
            this.message = e.message;
        }
    }

}


// WEBPACK FOOTER //
// src/web/ServerError.js